import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { ShopComponent } from "./shop/shop.component";
import { PagesComponent } from "./pages/pages.component";
import { ElementsComponent } from "./elements/elements.component";
import { MatrimonialsComponent } from "./matrimonials/matrimonials.component";
import { ForgotPasswordComponent } from "./matrimonials/admin/forgot-password/forgot-password.component";
import { AdminComponent } from "./admin/admin.component";
import { VendorModule } from "./vendor/vendor.module";
import { VendorComponent } from "./vendor/vendor.component";
import { AdminEditorComponent } from "./admin-editor/admin-editor.component";
import { InterviewerComponent } from "./interviewer/interviewer/interviewer.component";
import { CommonLoginComponent } from "./common-login/common-login.component";
import { UnauthorizedComponent } from "./shared/components/unauthorized/unauthorized.component";
import { RoleGuard } from "./services/role.guard";
import { OnlineExamComponent } from "./exams/online-exam/online-exam.component";
import { VendorRegistrationComponent } from "./vendor/vendor-registration/vendor-registration.component";
import { ImmediateHiringsComponent } from "./immediate-hirings/immediate-hirings.component";
import { PlansPriceComponent } from "./admin/plans-price/plans-price.component";
import { VendorSuccessPageComponent } from "./vendor/vendor-success-page/vendor-success-page.component";
import { PrivacyPolicyComponent } from "./shared/privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "./shared/terms-and-conditions/terms-and-conditions.component";
import { AdvertiseDetailsViewComponent } from "./advertise-details-view/advertise-details-view.component";
import { FaqsComponent } from "./faqs/faqs.component";
import { PricingPolicyComponent } from "./shared/pricing-policy/pricing-policy.component";
import { RefundPolicyComponent } from "./shared/refund-policy/refund-policy.component";
import { CancellationPolicyComponent } from "./shared/cancellation-policy/cancellation-policy.component";
import { ShippingPolicyComponent } from "./shared/shipping-policy/shipping-policy.component";
import { DetailBlogViewComponent } from "./detail-blog-view/detail-blog-view.component";
import { ValidatePaymentsComponent } from "./validate-payments/validate-payments.component";
import { PlanDetailPageComponent } from "./admin/plans-price/plan-detail-page/plan-detail-page.component";
import { VendorForgotPasswordComponent } from "./vendor/vendor-forgot-password/vendor-forgot-password.component";
import { CommonLoginRootComponent } from "./common-login-root/common-login-root.component";
import { VerifyVendorEmailComponent } from "./vendor/verify-vendor-email/verify-vendor-email.component";
import { VerifyBusinessPartnerEmailComponent } from "./verify-business-partner-email/verify-business-partner-email.component";
import { SuccessOnlineExamComponent } from "./exams/online-exam/success-online-exam/success-online-exam.component";
import { JobSeekerComponent } from "./job-seeker/job-seeker/job-seeker.component";
import { JobLandingComponent } from "./job-landing/job-landing.component";
import { SupportDocumentsComponent } from "./vendor/support-documents/support-documents.component";


const routes: Routes = [
  // {
  //   path: "",
  //   redirectTo: "home/jobportal",
  //   pathMatch: "full",
  // },
  {
    path: "",
    loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  },

  // {
  //   path: "home",
  //   loadChildren: () => import("./home/home.module").then((m) => m.HomeModule),
  // },

  {
    path: "shop",
    component: ShopComponent,
    loadChildren: () => import("./shop/shop.module").then((m) => m.ShopModule),
  },
  {
    path: "pages",
    component: PagesComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
  },
  {
    path: "elements",
    component: ElementsComponent,
    loadChildren: () =>
      import("./elements/elements.module").then((m) => m.ElementsModule),
  },

  {
    path: "mat-jobs",
    component: MatrimonialsComponent,
    loadChildren: () =>
      import("./matrimonials/matrimonials.module").then(
        (m) => m.MatrimonialsModule
      ),
  },

  {
    path: "admin",
    component: AdminComponent,
    loadChildren: () =>
      import("./admin/admin.module").then((m) => m.AdminModule),
  },


  {
    path: "vendor",
    component: VendorComponent,canActivate: [RoleGuard], data: { expectedRole: ['VENDOR','VENDOR_EMP'] },
    loadChildren: () =>
      import("./vendor/vendor.module").then((m) => m.VendorModule),
  },
  {
    path: "interviewer",
    component: InterviewerComponent,canActivate: [RoleGuard], data: { expectedRole: ['INTERVIEWER']}, 
    loadChildren: () =>
      import("../app/interviewer/interviewer/interviewer.module").then((m) => m.InterviewerModule),
  },
  {
    path: "login",
    component: CommonLoginComponent,
  },
  // {
  //   path: "login",
  //   component: CommonLoginRootComponent,
  // },
  
  {
    path: "register",
    component: VendorRegistrationComponent
  },

  {
    path: "online-exam",
    component: OnlineExamComponent,
    loadChildren: () =>
      import("../app/exams/exam.module").then((m) => m.ExamModule),
  },
  {
    path: "online-exam-success",
    component: SuccessOnlineExamComponent,
    loadChildren: () =>
      import("../app/exams/exam.module").then((m) => m.ExamModule),
  },

  {
    path: "immediate-hirings",
    component: ImmediateHiringsComponent
  },
  {
    path: "products-old",
    component:PlansPriceComponent,

  },

  {
    path: "job-seeker",
    component: JobSeekerComponent, 
    loadChildren: () =>
      import("../app/job-seeker/job-seeker/job-seeker.module").then((m) => m.JobSeekerModule),
  },

  {
    path: "privacy",
    component:PrivacyPolicyComponent,

  },
  {
    path: "terms-and-conditions",
    component:TermsAndConditionsComponent,

  },
    { path: "vendor-success", component: VendorSuccessPageComponent },
    {
      path: "advertise-view/:slug",
      component: AdvertiseDetailsViewComponent
    },
    {
      path: "faqs",
      component: FaqsComponent
    },
    {
      path: "pricing-policy",
      component:PricingPolicyComponent,
  
    },
    {
      path: "refund-policy",
      component:RefundPolicyComponent,
  
    },
    {
      path: "cancellation-policy",
      component:CancellationPolicyComponent,
  
    },
    {
      path: "shipping-policy",
      component:ShippingPolicyComponent,
  
    },
    {
      path: "job-hunting-mistakes",
      component:DetailBlogViewComponent,
  
    },

    { path: "product-details-old", 
      component: PlanDetailPageComponent
    },

    {
      path: "payments/:k",
      component:ValidatePaymentsComponent,
  
    },
    { path: "forgot-password", component: VendorForgotPasswordComponent },
    { path: "jobs-landing", component: JobLandingComponent },

  {
    path: "**", // Navigate to Home Page if not found any page
    redirectTo: "home/fashion",
  },
  { path: "verify-vendor", component:VerifyVendorEmailComponent },
  { path: "verify-business-partner", component:VerifyBusinessPartnerEmailComponent },
  { path: "support-documents", component:SupportDocumentsComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
